export default __webpack_public_path__ + "static/media/icon-signal.4bee14ce.svg";